export function getConfigurationBlocker(itemsState) {
  const unavailableItem = Object.values(itemsState.activeObjs).find((item) => item?.outOfStock === true || item?.isSoldOut === true);
  if (unavailableItem) {
    return `"${unavailableItem.displayName}" is unavailable. Please update your configuration.`;
  }

  if (itemsState.activeObjs["custom-patch-front"]._id === "customText-front-patch") {
    if (itemsState.activeObjs["custom-patch-front"].inputs.text_input.trim() === "") {
      return "Please update front patch text or remove patch.";
    }
  }

  if (itemsState.activeObjs["custom-patches-side"]._id === "customText-side-patches") {
    if (itemsState.activeObjs["custom-patches-side"].inputs.text_input.trim() === "") {
      return "Please update side patch text or remove patch.";
    }
  }

  if (itemsState.activeObjs["custom-patch-front"]._id === "customImage-front-patch") {
    const logoSrc = itemsState.activeObjs["custom-patch-front"].uploaded_logo_src;
    const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
    const isValidUrl = urlPattern.test(logoSrc);

    if (!itemsState.activeObjs["custom-patch-front"].uploaded_logo_base64 && !isValidUrl) {
      return "Please choose a front patch logo or remove patch.";
    }
  }

  return null;
}
